import * as React from 'react';
import CommonStreamItem, {StreamItemAction} from "../../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import InvoiceSentEvent from "../../../../model/invoice/event/InvoiceSentEvent";
import InvoiceSentEmailPreviewModal from "../../invoiceEmail/InvoiceSentEmailPreviewModal";


interface ComponentProps {
	/**
	 * Invoice activity to display.
	 */
	activity: InvoiceSentEvent;
}

interface State {
	/**
	 * Indicates if sent email preview modal is visible.
	 */
	emailPreviewVisible: boolean;
}

type Props = ComponentProps;

export default class InvoiceActivitySentItemWithAction extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {emailPreviewVisible: false};
	}

	render() {
		const htmlContent = this.props.activity.data.emailHtml;
		const actions: StreamItemAction[] = htmlContent.isDefined ?
			[StreamItemAction.new("Show sent email", () => this.setState({emailPreviewVisible: true}))] : undefined;
		return (
			<>
				<CommonStreamItem event={this.props.activity} actions={actions}/>
				{this.state.emailPreviewVisible &&
				<InvoiceSentEmailPreviewModal onCloseClicked={this.onModalClose} htmlContent={htmlContent}/>}
			</>
		);
	}

	onModalClose = () => this.setState({emailPreviewVisible: false});
}
